import { Box, Typography } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import SettingsIcon from "@material-ui/icons/Settings";
import { Backdrop } from "common/components/Backdrop";
import { ButtonCard } from "common/components/ButtonCard";
import { t } from "i18next";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { IApplicationState } from "redux/root-reducer";
import PullToRefresh from "../../common/components/PullToRefresh/PullToRefresh";
import { getAllMetersAction } from "../meter.actions";
import styles from "./dashboardForMeter.module.scss";
import { MeterHeadline } from "./meterHeadline";
import { MeterListView } from "./meterListView";

export const DashboardForMeter = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { domain, id }: any = useParams();
  const { isFetching } = useSelector(
    (state: IApplicationState) => state.meters
  );

  const handleRefresh = () => {
    dispatch(getAllMetersAction(domain, id));
  };

  return (
    <>
      <Backdrop open={isFetching} />
      <PullToRefresh onRefresh={handleRefresh} style={{ width: "100%" }}>
        <Box className={styles.container} display="flex" gridGap={15}>
          <MeterHeadline />
          <ButtonCard
            flexGrow={1}
            onClick={() =>
              history.push(
                `${domain ? `/${domain}` : ""}/profile/manage-notifications`
              )
            }
          >
            <Typography variant="h4">{t("Manage notifications")}</Typography>
            <SettingsIcon style={{ height: 24 }} />
          </ButtonCard>
          <ButtonCard flexGrow={0} onClick={handleRefresh}>
            <Typography variant="h4">{t("Update")}</Typography>
            <RefreshIcon />
          </ButtonCard>
          <MeterListView />
        </Box>
      </PullToRefresh>
    </>
  );
};
